import { initKpiCounters } from '../components/section_kpi/index';
import { initPartnersSliders } from '../components/section_partners/index';
import { initReviewsSliders } from '../components/section_reviews/index';
import { initCertificationsSliders } from '../components/section_certifications/index';
import { initStepsSliders } from '../components/section_steps/index';
import { initTimelineSliders } from '../components/section_timeline/index';
import { initFaqAccordion } from '../components/section_faq/index';
import { initSectionVideos } from '../components/section_video/index';
import { initTableScrollHints } from '../components/section_k_builder/index';
import { initSectionJMaps } from '../components/section_j/index';

document.addEventListener('DOMContentLoaded', () => {
    initSectionVideos();
    initKpiCounters();
    initPartnersSliders();
    initReviewsSliders();
    initCertificationsSliders();
    initStepsSliders();
    initTimelineSliders();
    initFaqAccordion();
    initTableScrollHints();
    initSectionJMaps();
});
